import React from 'react';
import parse from 'html-react-parser';
import { createRef } from 'react';
//components
import IconsHolder from '../icons-holder/IconsHolder';
import Accordion from 'react-bootstrap/Accordion';
//styles
import './styles/header-dropdown.scss';
//scripts
import { ifDesktop } from '../../scripts/helpers';
import { IMenu, ILinksObg } from '../../interfaces/header';
type HeaderDropdownProps = {
  backToMenu?: any;
  menu: IMenu;
};

type HeaderDropdownState = {
  tabHoverId: string;
};
class HeaderDropdown extends React.Component<HeaderDropdownProps, HeaderDropdownState> {
  constructor(props: HeaderDropdownProps) {
    super(props);
  }
  state = {
    tabHoverId: '',
    initialLoad: true,
  };
  tabRef: any = createRef();
  handleTabLinkMouseOver(id: string) {
    this.setState(() => ({
      tabHoverId: id,
    }));
  }
  handleTabLinkMouseLeave() {
    if (!this.tabRef.current.matches(':hover')) {
      this.setState(() => ({
        tabHoverId: '',
      }));
    }
  }
  backToMenu(id: string): void {
    this.props.backToMenu(id);
  }
  render() {
    return (
      <div className={`dropdown-wrapper ${this.props.menu.id}-drp`}>
        <div className="container py-3 d-flex d-lg-none back-menu">
          <button
            onClick={() => this.backToMenu(this.props.menu.id)}
            onKeyDown={(e) => {
              if (
                !ifDesktop() &&
                (e.nativeEvent.code === 'Enter' || e.nativeEvent.code === 'Space')
              ) {
                this.backToMenu(this.props.menu.id);
              }
            }}
            className="btn p-0 h6 text-center w-100"
            aria-label="Back to the previous menu.">
            <span>{this.props.menu.titleCopy}</span>
          </button>
        </div>
        <div className="content flex-fill justify-content-lg-between d-flex flex-column flex-lg-row">
          <div className="nav-links py-lg-4 text-sm-left pb-3">
            <ul className="container px-lg-0">
              {this.props.menu.drpMainCategories.map((category, index) => {
                if (category.link && category.title) {
                  return (
                    <li
                      key={index}
                      className={`d-flex align-items-center position-relative ${
                        this.state.tabHoverId === `${this.props.menu.id}-tab-${index}`
                          ? 'active'
                          : ''
                      }`}
                      onMouseEnter={() =>
                        this.handleTabLinkMouseOver(`${this.props.menu.id}-tab-${index}`)
                      }
                      onMouseLeave={(e) => this.handleTabLinkMouseLeave()}>
                      <IconsHolder
                        icon={category.icon}
                        variant="primary"
                        className="align-self-start"
                        size="md"
                      />
                      <div className="ms-3">
                        <a
                          className="h6 stretched-link"
                          onTouchEnd={(e) => {
                            this.handleTabLinkMouseOver(`${this.props.menu.id}-tab-${index}`);
                          }}
                          onTouchStart={(e) => {
                            e.nativeEvent.stopImmediatePropagation;
                            e.stopPropagation();
                            e.preventDefault();
                          }}
                          href={category.link}>
                          {parse(category.title)}
                        </a>
                        {category.subcopy && (
                          <p className="body-text-sm text-gray mb-0">{parse(category.subcopy)}</p>
                        )}
                      </div>
                    </li>
                  );
                }
              })}
            </ul>
          </div>
          <div
            ref={this.tabRef}
            className="nav-add flex-fill p-lg-6 bg-light justify-content-lg-between d-lg-flex align-items-lg-start pt-5 body-text-sm">
            <div className="tabs-container pe-lg-6 ps-lg-0 container mx-lg-0">
              {this.props.menu.drpTabFixed && (
                <div className="fixed-tab-container pb-3">
                  <h6 className="eyebrow-text mb-3 text-secondary">
                    {this.props.menu.drpTabFixed.title}
                  </h6>
                  <ul className="ps-0">
                    {this.props.menu.drpTabFixed.links.map((link: ILinksObg, i: number) => (
                      <li key={`header-${i}-key8`}>
                        <a href={link.link}>{parse(link.title)}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              <h6
                id={`${this.props.menu.id}-advtitle`}
                className="eyebrow-text mb-lg-3 text-secondary">
                {this.props.menu.adviceTitle}
              </h6>
              <Accordion
                flush
                id={`${this.props.menu.id}-tab-wrap`}
                alwaysOpen
                className="tab-wrap mb-0 accordion-plus-icon accordion-lg-none">
                {this.props.menu.drpMainCategories.map((cat, index) => (
                  <Accordion.Item
                    key={`${this.props.menu.id}-key2-${index}`}
                    eventKey={`${this.props.menu.id}-tab${index}-wrap`}>
                    <Accordion.Button
                      aria-controls={`${this.props.menu.id}-tab${index}`}
                      className="tabpanel-control body-text-sm d-lg-none">
                      {cat.advice.mobileTitle}
                    </Accordion.Button>
                    <Accordion.Body
                      aria-labelledby={`${this.props.menu.id}-advtitle`}
                      as="ul"
                      id={`${this.props.menu.id}-tab${index}`}
                      className={`advice-box pl-md-0 ${
                        this.state.tabHoverId === `${this.props.menu.id}-tab-${index}` ||
                        (!this.state.tabHoverId && index === 0)
                          ? 'd-lg-block'
                          : 'd-lg-none'
                      }`}>
                      {cat.advice.links.map((link, i) => (
                        <li key={`${this.props.menu.id}-key3-${i}`}>
                          <a href={`${link.link}`}>{parse(link.title)}</a>
                        </li>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
            <div className="container promo-cont px-lg-0 mt-5 mt-lg-0 pb-9 pb-lg-0 mx-lg-0">
              <div className="promo d-flex flex-lg-wrap ">
                <div
                  aria-hidden="true"
                  className="spot-icon-md mb-lg-3 mx-lg-auto me-3"></div>
                <div className="w-100">
                  <p className="eyebrow-text mb-0 text-primary">
                    {parse(this.props.menu.promo.badge)}
                  </p>
                  <h6>{parse(this.props.menu.promo.title)}</h6>
                  <p className="text-gray body-text-sm">{parse(this.props.menu.promo.body)}</p>
                  <a
                    href={this.props.menu.promo.link}
                    className="btn btn-outline-gray"
                    {...(this.props.menu.promo.link.indexOf('registration') > -1 && {
                      'data-op': 'MNT',
                    })}>
                    {this.props.menu.promo.linkTitle}
                  </a>
                </div>
              </div>
              {this.props.menu.underPromo && (
                <p className="body-text-xs mb-0 mt-4 text-gray">
                  {parse(this.props.menu.underPromo)}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HeaderDropdown;
